import { render, staticRenderFns } from "./ComoChegar.vue?vue&type=template&id=3b2acbf4&scoped=true&lang=pug"
import script from "./ComoChegar.vue?vue&type=script&lang=js"
export * from "./ComoChegar.vue?vue&type=script&lang=js"
import style0 from "./ComoChegar.styl?vue&type=style&index=0&id=3b2acbf4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2acbf4",
  null
  
)

export default component.exports